module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular-fa2772.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff
 ** module id = 911
 ** module chunks = 2
 **/